const initialState = {}

export default function main(state = initialState, action) {
  switch(action.type) {
  case 'SET_STATE_SEARCH':
    return Object.assign({}, state, action.params)
  default:
    return state
  }
}
